import { Node } from '../Node';
import { AirTankType } from './AirTankNodeFactory';

export class AirTankNodeModel extends Node {
  constructor(type: AirTankType, device?, options = {}) {
    super({
      device,
      options,
      type,
    });
  }
}
